import { useState } from 'react';
import { appointCommander, type SessionFull } from '../api/missions';
import { ca } from '../i18n/ca';
import { AccountPicker } from './AccountPicker';
import { errorText } from './useSessionLive';

/**
 * What the commander of the night reads on the session page (study 6.3): that the
 * command is theirs on this session only, what it lets them do, and the way to hand
 * it to another player, picked from the accounts that match what is typed. Drawn for the
 * commander alone; once the command is handed over the new view says so and the band is gone.
 */
export function CommanderBand({
  code,
  onData,
  onHandedOver,
  onError,
}: {
  code: string;
  onData: (data: SessionFull) => void;
  /** Who took the command, for the line the page says once the band is gone. */
  onHandedOver: (name: string) => void;
  onError: (text: string | null) => void;
}) {
  const [handle, setHandle] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!handle.trim()) return;
    setBusy(true);
    appointCommander(code, handle.trim())
      .then((d) => {
        onData(d);
        if (d.commander) onHandedOver(d.commander.displayName);
        setHandle('');
        onError(null);
      })
      .catch((err) => onError(errorText(err)))
      .finally(() => setBusy(false));
  };
  return (
    <section className="band commander-band" aria-label={ca.live.youCommand}>
      <i className="bi bi-star" aria-hidden="true" />
      <div className="grow">
        <strong className="band-title">{ca.live.youCommand}</strong>
        <p className="muted small">{ca.live.youCommandText}</p>
      </div>
      <form className="row" onSubmit={submit} aria-label={ca.live.handOver}>
        <AccountPicker code={code} label={ca.live.handOverTo} value={handle} onChange={setHandle} />
        <button type="submit" disabled={busy || !handle.trim()}>
          <i className="bi bi-arrow-left-right" aria-hidden="true" /> {ca.live.handOver}
        </button>
      </form>
    </section>
  );
}
